import { Button } from "../Elements";
import { Link, useNavigate } from "react-router-dom";

export default function BottomButtons({ isLoading }) {
  let navigate = useNavigate();

  return (
    <div className="w-full ">
      <div className={"m-4 flex flex-row justify-end bg-white shadow-md rounded-md"}>
        <div className="m-4 p-4 space-x-4 flex flex-row">
          <Button
            type="button"
            size="lg"
            color="gray"
            hover="gray"
            callback={() => {
              navigate(-1);
            }}
          >
            Geri Dön
          </Button>
          <Button
            type="submit"
            size="lg"
            color="primary"
            hover="primary"
            spanClass={"ml-1.5 mr-1.5 "}
            loading={isLoading}
          >
            Kaydet
          </Button>

        </div>
      </div>
    </div>
  );
}
